import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/auth"); return; }

    const role = sessionStorage.getItem("pending_role") || undefined;
    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id, role });
        if (r.data.session_token) localStorage.setItem("session_token", r.data.session_token);
        setUser(r.data.user);
        sessionStorage.removeItem("pending_role");
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard");
      } catch (e) {
        const detail = e.response?.data?.detail || e.message;
        console.error("Google sign-in failed:", e.response?.status, detail);
        toast.error(`Google sign-in failed: ${detail}`);
        window.history.replaceState({}, "", "/auth");
        navigate("/auth");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="text-slate-400 font-mono-data">Establishing session…</div>
    </div>
  );
}
